import React, { useState, useEffect } from "react";
import "./cookieConsent.scss";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // перевіряємо, чи користувач уже прийняв кукі
    const accepted = localStorage.getItem("cookieAccepted");
    if (!accepted) {
      setTimeout(() => setVisible(true), 500); // трохи затримки для плавності
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          Używamy plików cookie, aby zapewnić najlepsze doświadczenia na naszej stronie.
          Kontynuując korzystanie z serwisu, zgadzasz się na ich użycie zgodnie z naszą
          <a href="/polityka-prywatności"> Polityką prywatności</a>.
        </p>
        <button onClick={handleAccept}>Akceptuję</button>
      </div>
    </div>
  );
};

export default CookieConsent;
